import { LandingComponentsConfig, LandingScreenSchema } from '@/modules/Landing/instances/@types/landing-types'

const schema: LandingScreenSchema = {
	order: ['LandingHead', 'LandingTitle', 'LandingSubtitle', 'LandingAgeGrid'],

	components: {
		LandingTitle: (): LandingComponentsConfig['LandingTitle'] => ({
			title: '28-DAY BARRE<br/>WORKOUT PLAN',
			size: 'large',
		}),

		LandingSubtitle: ({ $t }): LandingComponentsConfig['LandingSubtitle'] => ({
			uppercase: true,
			title: $t('female_activity.pages.landing.step_1.subtitle', {
				age: `<b>${$t('female_activity.pages.landing.step_1.age')}</b>`,
			}),
		}),

		LandingAgeGrid: (): LandingComponentsConfig['LandingAgeGrid'] => ({
			theme: 'purple',
			ageRanges: [
				{
					value: 18,
					analyticValue: '18-29',
					label: 'Age: 18-29',
					img: require('@/assets/landing-activity-female/hiit-f-20.png'),
				},
				{
					value: 30,
					analyticValue: '30-39',
					label: 'Age: 30-39',
					img: require('@/assets/landing-activity-female/hiit-f-30.png'),
				},
				{
					value: 40,
					analyticValue: '40-49',
					label: 'Age: 40-49',
					img: require('@/assets/landing-activity-female/activity-senior-f-40.webp'),
				},
				{
					value: 50,
					analyticValue: '50-59',
					label: 'Age: 50+',
					img: require('@/assets/landing-activity-female/activity-senior-f-50.webp'),
				},
			],
		}),
	},
}

export default schema
